module.exports = __webpack_public_path__ + "img/logo-vertical.d2d18225.svg";